export class Toast {

    constructor(store) {
        this.container = document.createElement("div");
        this.container.className = "toast-container";
        document.body.appendChild(this.container);
        this.store = store;
    }

    show(message, type = "success", duration = 3000, callback) {
        const toast = document.createElement("div");
        toast.className = `toast ${type}`;
        if (type === "CHOOSE") {
            const text = document.createElement("div");
            text.className = "font-20";
            text.textContent = message;
            const textWrapper = document.createElement("div");
            textWrapper.className = "width-100 height-15 row padding-top-5 padding-bottom-5";
            const from = document.createElement("div");
            from.className = "width-45 height-100 row font-15 justify-right margin-right-5";
            from.textContent = this.store.database.moveFrom.name + "\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0-->";
            const to = document.createElement("div");
            to.className = "width-45 height-100 font-15";
            to.textContent = this.store.database.moveTo.name;
            textWrapper.append(from, to)
            const buttonWrapper = document.createElement("div");
            buttonWrapper.className = "width-100 height-100 row padding-bottom-5 justify-evenly";
            const ok = document.createElement("img");
            ok.src = "/assets/buttonOK.png";
            ok.className = "width-40 height-60";
            ok.style.objectFit = "contain";
            const no = document.createElement("img");
            no.src = "/assets/buttonNO.png";
            no.className = "width-40 height-60";
            no.style.objectFit = "contain";
            buttonWrapper.append(ok, no);
            toast.append(text, textWrapper, buttonWrapper);
            ok.addEventListener("click", e => {
                e.preventDefault();
                e.stopPropagation();
                callback(true);
                toast.classList.remove("show");
                toast.classList.add("hide");
            });
            no.addEventListener("click", e => {
                e.preventDefault();
                e.stopPropagation();
                callback(false);
                toast.classList.remove("show");
                toast.classList.add("hide");
            });
        }else if (type === "UPLOAD") {
            const text = document.createElement("div");
            text.className = "font-20";
            text.textContent = message;
            const buttonWrapper = document.createElement("div");
            buttonWrapper.className = "width-100 height-100 row padding-top-10 padding-bottom-5 justify-evenly";
            const upload = document.createElement("img");
            upload.src = "/assets/buttonOK.png";
            upload.className = "width-45 height-65";
            upload.style.objectFit = "contain";
            const reset = document.createElement("img");
            reset.src = "/assets/buttonNO.png";
            reset.style.objectFit = "contain";
            reset.className = "width-45 height-65";
            buttonWrapper.append(upload, reset);
            toast.append(text, buttonWrapper);
            upload.addEventListener("click", e => {
                e.preventDefault();
                e.stopPropagation();
                const input = document.createElement("input");
                input.type = "file";
                input.accept = "application/pdf";
                input.style.display = "none";
                document.body.appendChild(input);
                input.addEventListener("change", () => {
                    const file = input.files[0];
                    if (file) {callback(file);
                    } else {callback(null);}
                    input.remove();
                    toast.classList.remove("show");
                    toast.classList.add("hide");
                }, { once: true });
                input.click();
            });
            reset.addEventListener("click", e => {
                e.preventDefault();
                e.stopPropagation();
                callback(false);
                toast.classList.remove("show");
                toast.classList.add("hide");
            });}
            else {toast.textContent = message;}

        this.container.appendChild(toast);
        requestAnimationFrame(() => toast.classList.add("show"));
        if (type !== "CHOOSE" && type !== "UPLOAD") {
            setTimeout(() => {
                toast.classList.remove("show");
                toast.classList.add("hide");
                toast.addEventListener("transitionend", () => toast.remove(), { once: true });
            }, duration);
        }
    }

    success(msg){this.show(msg,"success");}

    error(msg){this.show(msg,"error");}

    warning(msg){this.show(msg,"warning");}

    choose(msg){return new Promise(resolve => {this.show(msg, "CHOOSE", 0, resolve);});
    }

    upload(msg){return new Promise(resolve => {this.show(msg, "UPLOAD", 0, resolve);});
    }

}